import { useFilter } from '../../contexts/FilterContext'
import PlayerDetailsContainer from '../PlayerDetailsContainer/PlayerDetailsContainer'
import TeamData from '../../data/TeamData'
import MatchList from '../MatchList/MatchList'
import './DetailsPanel.css'
import { Route, Switch, Redirect } from 'react-router-dom'

const DetailsPanel = () => {
  const appliedFilters = useFilter()

  return (
    <div className="detailsPanel">
      <Switch>
        <Route exact path="/">
          <Redirect to="/match" />
        </Route>
        <Route exact path="/match">
          <MatchList />
        </Route>
        <Route exact path="/team">
          <PlayerDetailsContainer
            team={
              TeamData.filter(
                (team) => team.team_id === appliedFilters.selectedTeamId
              )[0]
            }
            playerId={appliedFilters.selectedPlayerId}
          />
        </Route>
      </Switch>
    </div>
  )
}

export default DetailsPanel
